import { render, staticRenderFns } from "./Provisionstabelle.vue?vue&type=template&id=3d0496ce&scoped=true&"
import script from "./Provisionstabelle.vue?vue&type=script&lang=js&"
export * from "./Provisionstabelle.vue?vue&type=script&lang=js&"
import style0 from "./Provisionstabelle.vue?vue&type=style&index=0&id=3d0496ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0496ce",
  null
  
)

export default component.exports